var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14H10.5C9.09375 14 8 15.125 8 16.5C8 16.7812 8.21875 17 8.5 17H14.5C14.75 17 15 16.7812 15 16.5C15 15.125 13.875 14 12.5 14ZM11.5 13C12.5938 13 13.5 12.125 13.5 11C13.5 9.90625 12.5938 9 11.5 9C10.375 9 9.5 9.90625 9.5 11C9.5 12.125 10.375 13 11.5 13ZM19.5 15H19V18H19.5C19.75 18 20 17.7812 20 17.5V15.5C20 15.25 19.75 15 19.5 15ZM19.5 7H19V10H19.5C19.75 10 20 9.78125 20 9.5V7.5C20 7.25 19.75 7 19.5 7ZM19.5 11H19V14H19.5C19.75 14 20 13.7812 20 13.5V11.5C20 11.25 19.75 11 19.5 11ZM16 5H7C5.875 5 5 5.90625 5 7V19C5 20.125 5.875 21 7 21H16C17.0938 21 18 20.125 18 19V7C18 5.90625 17.0938 5 16 5ZM16.5 19C16.5 19.2812 16.25 19.5 16 19.5H7C6.71875 19.5 6.5 19.2812 6.5 19V7C6.5 6.75 6.71875 6.5 7 6.5H16C16.25 6.5 16.5 6.75 16.5 7V19Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/Contacts.5024b534bfa034d2a535df82ddcb9065.svg";
export { ForwardRef as ReactComponent };